import api from '../../apiConfig/apiConfig';
import { Post, Get } from '../base/baseAjax';
export function searchUser(param) {
  return Post({
    url: api.sso.searchUser,
    bodyParam: param,
  });
}
export function getUserInfo(token = localStorage.getItem('Authorization')) {
  return Get({
    url: api.sso.getUserInfo + token,
  });
}
